// ignore-string-externalization
import createDebug from 'debug';
import { TransportEvent, Transport } from '@spotify-internal/transport';
import {
  createClientIdContext,
  createUserAgentContext,
} from '@spotify-internal/event-sender/es5/contexts';
import { createEventSender } from '@spotify-internal/event-sender';
import { getSpotifyClientId } from '@mrkt/features/env';
import {
  nonAuthTransport,
  transport as authTransport,
} from '@mrkt/features/Platform/transport';

const debug = createDebug('gabito:logger');

type Options = {
  transport: Transport;
  clientId: string;
};

export type GabitoEvent = {
  name: string;
  data: {
    [key: string]: string | number | boolean | null | undefined;
  };
};

export function createGabitoLogger({ transport, clientId }: Options) {
  if (!process.browser) {
    return () => {};
  }
  const clientIdContext = createClientIdContext(clientId);

  const userAgentContext = createUserAgentContext(window.navigator.userAgent);

  const logger = createEventSender({
    transport,
    context: [clientIdContext, userAgentContext],
  });

  return function logGabitoEvent(event: GabitoEvent) {
    debug(event);
    logger.send(event);
  };
}

export function createAuthenticatedGabitoLogger(options: Options) {
  if (!process.browser) {
    return () => {};
  }
  const { transport } = options;

  const authenticated = new Promise(resolve => {
    transport.on(TransportEvent.AUTHENTICATED, resolve);
  });

  const logGabitoEvent = createGabitoLogger(options);

  return function logAuthenticatedGabitoEvent(event: GabitoEvent) {
    authenticated.then(() => {
      logGabitoEvent(event);
    });
  };
}

export const logGabitoEvent = createAuthenticatedGabitoLogger({
  transport: authTransport,
  clientId: getSpotifyClientId(),
});

export const logNonAuthGabitoEvent = createGabitoLogger({
  transport: nonAuthTransport,
  clientId: getSpotifyClientId(),
});
